import { makeStyles } from 'tss-react/mui';
import { TreeItem } from '@mui/x-tree-view';
import { Typography } from '@mui/material';
import { useSharedStyles } from '../../../../utilities/Styles';
import { multiClass } from '../../../../utilities/Extensions';
import {
  composeNodeID,
  engagedHoursWorkedAmountNodeID,
  engagedHoursWorkedRateNodeID,
} from '../../../../variables/PayHistory';
import SingleTextNode from '../SingleTextNode';
import { AppliedRate } from '../../../../interfaces/PayHistory/AppliedRate';

interface EngagedHoursWorkedWithRateNodeProps {
  id: string;
  hoursWorked: AppliedRate[];
}

const EngagedHoursWorkedWithRateNode = (
  props: EngagedHoursWorkedWithRateNodeProps,
) => {
  const { classes } = useStyles();
  const sharedClasses = useSharedStyles().classes;

  return (
    <TreeItem
      nodeId={props.id}
      label={
        <Typography
          className={multiClass([classes.label, sharedClasses.body1])}
        >{`Engaged Hours [${props.hoursWorked.length.toString()}]`}</Typography>
      }
    >
      {props.hoursWorked.map((hoursWorked, i) => (
        <TreeItem
          nodeId={composeNodeID([props.id, i.toString()])}
          label={
            <Typography
              className={multiClass([classes.label, sharedClasses.body1])}
            >
              {`${i.toString()} {${Object.keys(
                hoursWorked,
              ).length.toString()}}`}
            </Typography>
          }
        >
          <SingleTextNode
            id={composeNodeID([
              props.id,
              i.toString(),
              engagedHoursWorkedRateNodeID,
            ])}
            name='Engaged Hours Rate'
            value={(hoursWorked.rate / 100).toString()}
          />
          <SingleTextNode
            id={composeNodeID([
              props.id,
              i.toString(),
              engagedHoursWorkedAmountNodeID,
            ])}
            name='Engaged Hours'
            value={hoursWorked.amount.toString()}
          />
        </TreeItem>
      ))}
    </TreeItem>
  );
};

const useStyles = makeStyles()((theme) => ({
  label: {
    marginTop: theme.spacing(0.25),
    marginBottom: theme.spacing(0.25),
  },
}));

export default EngagedHoursWorkedWithRateNode;
